export const ratingConstants = {
  entityRating: 'Issuer Rating',
  entityRatingCurrency: 'Issuer Rating (foreign currency)',
  longTermRating: 'Long-term Rating',
  longTermRatingCurrency: 'Long-term rating (local currency)',
  entityReview: 'Entity review',
};

export const ratingRange = {
  longTermRange: 'LONG_TERM_RANGE',
  undeterminedRange: 'UNDETERMINED_RANGE',
  shortTermRange: 'SHORT_TERM_RANGE',
};

export const companyAvailableRating = [
  ratingConstants.entityRating,
  ratingConstants.entityRatingCurrency,
  ratingConstants.longTermRating,
  ratingConstants.longTermRatingCurrency,
];
